/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlCategory3 } from './ControlCategory3';
import {
    ControlCategory3FromJSON,
    ControlCategory3FromJSONTyped,
    ControlCategory3ToJSON,
} from './ControlCategory3';
import type { ControlGroupSummary } from './ControlGroupSummary';
import {
    ControlGroupSummaryFromJSON,
    ControlGroupSummaryFromJSONTyped,
    ControlGroupSummaryToJSON,
} from './ControlGroupSummary';
import type { ControlIntegrationPlatform1 } from './ControlIntegrationPlatform1';
import {
    ControlIntegrationPlatform1FromJSON,
    ControlIntegrationPlatform1FromJSONTyped,
    ControlIntegrationPlatform1ToJSON,
} from './ControlIntegrationPlatform1';
import type { ControlSeverity2 } from './ControlSeverity2';
import {
    ControlSeverity2FromJSON,
    ControlSeverity2FromJSONTyped,
    ControlSeverity2ToJSON,
} from './ControlSeverity2';
import type { ControlStatus3 } from './ControlStatus3';
import {
    ControlStatus3FromJSON,
    ControlStatus3FromJSONTyped,
    ControlStatus3ToJSON,
} from './ControlStatus3';
import type { ControlVerdict4 } from './ControlVerdict4';
import {
    ControlVerdict4FromJSON,
    ControlVerdict4FromJSONTyped,
    ControlVerdict4ToJSON,
} from './ControlVerdict4';

/**
 * 
 * @export
 * @interface ControlDetectionListItem
 */
export interface ControlDetectionListItem {
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    caseSid?: string;
    /**
     * 
     * @type {ControlCategory3}
     * @memberof ControlDetectionListItem
     */
    category: ControlCategory3;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionListItem
     */
    containsHVA: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionListItem
     */
    containsVIP: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionListItem
     */
    excluded: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    exclusionId?: string;
    /**
     * 
     * @type {Array<ControlGroupSummary>}
     * @memberof ControlDetectionListItem
     */
    groupSummaries: Array<ControlGroupSummary>;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    id: string;
    /**
     * 
     * @type {ControlIntegrationPlatform1}
     * @memberof ControlDetectionListItem
     */
    integrationPlatform: ControlIntegrationPlatform1;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionListItem
     */
    reingested: boolean;
    /**
     * 
     * @type {ControlSeverity2}
     * @memberof ControlDetectionListItem
     */
    severity: ControlSeverity2;
    /**
     * 
     * @type {number}
     * @memberof ControlDetectionListItem
     */
    severityOrdinal: number;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    sid: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    sourceDetectedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    sourceName?: string;
    /**
     * 
     * @type {ControlStatus3}
     * @memberof ControlDetectionListItem
     */
    status: ControlStatus3;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionListItem
     */
    teamName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionListItem
     */
    testMode: boolean;
    /**
     * 
     * @type {ControlVerdict4}
     * @memberof ControlDetectionListItem
     */
    verdict: ControlVerdict4;
}

/**
 * Check if a given object implements the ControlDetectionListItem interface.
 */
export function instanceOfControlDetectionListItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "containsHVA" in value;
    isInstance = isInstance && "containsVIP" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "excluded" in value;
    isInstance = isInstance && "groupSummaries" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "integrationPlatform" in value;
    isInstance = isInstance && "reingested" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "severityOrdinal" in value;
    isInstance = isInstance && "sid" in value;
    isInstance = isInstance && "sourceDetectedAt" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "testMode" in value;
    isInstance = isInstance && "verdict" in value;

    return isInstance;
}

export function ControlDetectionListItemFromJSON(json: any): ControlDetectionListItem {
    return ControlDetectionListItemFromJSONTyped(json, false);
}

export function ControlDetectionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDetectionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseSid': !exists(json, 'caseSid') ? undefined : json['caseSid'],
        'category': ControlCategory3FromJSON(json['category']),
        'containsHVA': json['containsHVA'],
        'containsVIP': json['containsVIP'],
        'createdAt': json['createdAt'],
        'excluded': json['excluded'],
        'exclusionId': !exists(json, 'exclusionId') ? undefined : json['exclusionId'],
        'groupSummaries': ((json['groupSummaries'] as Array<any>).map(ControlGroupSummaryFromJSON)),
        'id': json['id'],
        'integrationPlatform': ControlIntegrationPlatform1FromJSON(json['integrationPlatform']),
        'reingested': json['reingested'],
        'severity': ControlSeverity2FromJSON(json['severity']),
        'severityOrdinal': json['severityOrdinal'],
        'sid': json['sid'],
        'sourceDetectedAt': json['sourceDetectedAt'],
        'sourceName': !exists(json, 'sourceName') ? undefined : json['sourceName'],
        'status': ControlStatus3FromJSON(json['status']),
        'teamId': json['teamId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'testMode': json['testMode'],
        'verdict': ControlVerdict4FromJSON(json['verdict']),
    };
}

export function ControlDetectionListItemToJSON(value?: ControlDetectionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseSid': value.caseSid,
        'category': ControlCategory3ToJSON(value.category),
        'containsHVA': value.containsHVA,
        'containsVIP': value.containsVIP,
        'createdAt': value.createdAt,
        'excluded': value.excluded,
        'exclusionId': value.exclusionId,
        'groupSummaries': ((value.groupSummaries as Array<any>).map(ControlGroupSummaryToJSON)),
        'id': value.id,
        'integrationPlatform': ControlIntegrationPlatform1ToJSON(value.integrationPlatform),
        'reingested': value.reingested,
        'severity': ControlSeverity2ToJSON(value.severity),
        'severityOrdinal': value.severityOrdinal,
        'sid': value.sid,
        'sourceDetectedAt': value.sourceDetectedAt,
        'sourceName': value.sourceName,
        'status': ControlStatus3ToJSON(value.status),
        'teamId': value.teamId,
        'teamName': value.teamName,
        'testMode': value.testMode,
        'verdict': ControlVerdict4ToJSON(value.verdict),
    };
}

